import { Form, Input, InputNumber } from "antd";
import { IEditableCellProps } from "../../interfaces/props/IEditableCellProps";

import classes from './EditableCell.module.css';

export const EditableCell = <T,>({
  editing,
  dataIndex,
  title,
  inputType,
  record: T,
  index,
  children,
  ...restProps
}: React.PropsWithChildren<IEditableCellProps<T>>) => {
  const inputNode = inputType === 'data' ? <Input  className={classes.editableCellInput}/>: <InputNumber className={classes.editableCellInputNumber} /> ;
  
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
          className={classes.editableCellFormItem}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
}

  